import { createAction, props } from '@ngrx/store';
import { PageViewEvent } from '@snowplow/browser-tracker-core';
import { CommonEventProperties, LinkClickEvent, SelfDescribingEvent } from '@snowplow/tracker-core';

import {
  SnowplowAnonymizationConfiguration,
  SnowplowConfiguration,
  SnowplowEnableYoutubeTrackingParams,
} from './snowplow.models';

export const initialize = createAction('[Tracking][Snowplow] Initialize', props<SnowplowConfiguration>());
export const anonymize = createAction('[Tracking][Snowplow] Anonymize', props<SnowplowAnonymizationConfiguration>());
export const setUserId = createAction('[Tracking][Snowplow] Set user id', props<{ tokenSub?: string }>());
export const enableYoutubeTracking = createAction(
  '[Tracking][Snowplow] Enable YouTube tracking',
  props<SnowplowEnableYoutubeTrackingParams>()
);
export const pageView = createAction(
  '[Tracking][Snowplow] Page view',
  props<PageViewEvent & CommonEventProperties & { title_context?: string; enriched?: boolean }>()
);
export const selfDescribingEvent = createAction(
  '[Tracking][Snowplow] Self-describing event',
  props<SelfDescribingEvent & CommonEventProperties & { enriched?: boolean }>()
);
export const linkClick = createAction(
  '[Tracking][Snowplow] Link click',
  props<LinkClickEvent & CommonEventProperties & { enriched?: boolean }>()
);
